import React from 'react';
import { LoginForm } from '@/components/auth/LoginForm';

export const Auth: React.FC = () => {
  return <LoginForm />;
};